import { ArrowLeftOutlined } from '@ant-design/icons'
import { useUiKitContext } from '../../../utils/UiKitProvider/UiKitProvider'
import Button, { type ButtonProps } from '../Button'

type BackButtonProps = Pick<ButtonProps, 'onClick' | 'className'> & {
  children?: string
}

const BackButton = (props: BackButtonProps) => {
  const { onClick, children, ...restProps } = props

  const { translation: t } = useUiKitContext()

  const text = children || t('general.buttons.back')

  return (
    <Button
      onClick={onClick}
      variant="text"
      icon={<ArrowLeftOutlined />}
      {...restProps}
    >
      {text}
    </Button>
  )
}

export default BackButton
